import { useEffect, useRef } from 'react';
/**
 * similar to `useEffect` but gets triggered only when value changes
 * @param fn executable function on dependency updates
 * @param inputs dependency array
 */
export function useDidUpdateEffect(fn, inputs) {
    var didMountRef = useRef(false);
    useEffect(function () {
        if (didMountRef.current)
            fn();
        else
            didMountRef.current = true;
    }, inputs);
}



//////////////////
// WEBPACK FOOTER
// ./src/components/MultiSelect/hooks/UseDidUpdateEfect.tsx
// module id = 502
// module chunks = 0